import api from "@/router/api"

export default {
    getAllIndustryOwnerships({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesIndustryOwnerships.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_INDUSTRY_OWNERSHIPS', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener las industrias',
                })
            })
        })
    },
}
